class Trigger{
    constructor(trigger = {}){
        this.id = trigger.id ? trigger.id : 0
        this.triggercode = trigger.triggercode ? trigger.triggercode : "" 
        this.active = trigger.active ? trigger.active : false
        this.selected = trigger.selected ? trigger.selected : false
        this.name = trigger.name ? trigger.name : false
        // VLV
        this.minValue = trigger.minValue ? trigger.minValue : 0
        this.maxValue = trigger.maxValue ? trigger.maxValue : 0
        this.minActive = trigger.minActive ? trigger.minActive : false
        this.maxActive = trigger.maxActive ? trigger.maxActive : false
        // VLT
        this.minutes = trigger.minutes ? trigger.minutes : 1
        this.unconformities = trigger.unconformities ? trigger.unconformities : 1
    }
}

function DefaultTriggerList(triggers = new Array) {
  let result = triggers.map(t => new Trigger(t)).filter(t => t.triggercode != "MAN")
  return result
}

export {
  Trigger,
  DefaultTriggerList
}